import React, {Component} from "react";
import ModuleVideoListItem from "./ModuleVideoListItem.js";
import ModuleVideoMultimediaWeek from "./ModuleVideoMultimediaWeek.js";
import {connect} from "react-redux";

class ModuleVideoList extends Component {
    render() {
        let component;
        if (!this.props.moduleVideoList ||
            (this.props.moduleVideoList.weblecture.length === 0 &&
            this.props.moduleVideoList.multimedia.length === 0)) {
            component = (
                <div>
                    No available videos in this module
                </div>
            );
        } else {
            let videos = [];
            if (this.props.moduleVideoList.multimedia.length > 0) {
                videos.push(getMultimediaComponentArray(this.props.moduleVideoList, this.props.midx));
            }
            if (this.props.moduleVideoList.weblecture.length > 0) {
                videos.push(getWebcastComponentArray(this.props.moduleVideoList, this.props.midx, this.props.collapse, videos.length>0));
            }
            component = (
                <div className="module-video-list-wrapper">
                    <div className="list-group">
                        {videos}
                    </div>
                </div>
            );
        }
        return component;
    }
}
function getWebcastComponentArray(moduleVideoList, midx, collapse, mediaExist = false) {
    if (moduleVideoList.weblecture && moduleVideoList.weblecture.map) {
        let lectures = moduleVideoList.weblecture.map(v =>
            <ModuleVideoListItem {...v} key={v.ID}/>
        ).sort((a, b) => ModuleVideoListItem.compare(a, b));
        if (mediaExist) {
            let id = midx + '-weblecture';
            let classes = 'collapse ' + (collapse && collapse[id] ? 'show' : '');
            return(
                <div className="card">
                <div className="card-header">
                    <h5 className="week-title-h5 mb-0">
                        <a data-toggle="collapse" href={'#' + id} aria-controls={id} aria-expanded="false">
                            Web Lectures
                        </a>
                    </h5>
                </div>
                    <div id={id} className={classes}>
                        <div className="card-block">
                            {lectures}
                        </div>
                    </div>
                </div>
            );
        } else {
            return lectures;
        }
    }
    return [];
}
function getMultimediaComponentArray(moduleVideoList, midx) {
    let result = [];
    if (Array.isArray(moduleVideoList.multimedia)) {
        result = moduleVideoList.multimedia.map((w, idx) => {
            return <ModuleVideoMultimediaWeek key={idx} week={w} midx={midx} widx={'w' + idx}/>;
        }).sort((a, b) => ModuleVideoMultimediaWeek.compare(a, b));
    }
    return result;
}
let mapStateToProps = (state) => {
    return {
        collapse: state.collapse
    };
};
export default connect(mapStateToProps)(ModuleVideoList);


// WEBPACK FOOTER //
// ./src/componentsBody/ModuleVideoList.js